import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "review" }
const _hoisted_2 = { class: "review__inner" }
const _hoisted_3 = {
  class: "review__progress",
  "aria-label": "پیشرفت مرور"
}
const _hoisted_4 = { class: "review__progress-track" }
const _hoisted_5 = { class: "review__progress-text" }
const _hoisted_6 = { class: "review__card-face review__card-face--front" }
const _hoisted_7 = {
  key: 0,
  class: "review__badge"
}
const _hoisted_8 = { class: "review__word" }
const _hoisted_9 = {
  key: 1,
  class: "review__phonetic"
}
const _hoisted_10 = {
  key: 2,
  class: "review__pos"
}
const _hoisted_11 = { class: "review__card-face review__card-face--back" }
const _hoisted_12 = {
  key: 0,
  class: "review__badge"
}
const _hoisted_13 = { class: "review__definition" }
const _hoisted_14 = {
  key: 1,
  class: "review__example"
}
const _hoisted_15 = { class: "review__actions" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { getLeitnerReview, submitLeitnerReview } from "@/api/leitner";
import { handleError } from "@/services/errorHandler";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import EmptyState from "@/components/common/EmptyState.vue";
import type { VocabCard } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeitnerReview',
  setup(__props) {

const router = useRouter();
const cards = ref<VocabCard[]>([]);
const index = ref(0);
const flipped = ref(false);
const loading = ref(true);
const submitting = ref(false);
const finished = ref(false);
const errorMessage = ref<string | null>(null);
const reviewedCount = ref(0);

const current = computed(() => cards.value[index.value] || null);
const totalInSession = computed(() => cards.value.length);
const progressWidth = computed(() => {
  if (!totalInSession.value) return "0%";
  return `${Math.round((reviewedCount.value / totalInSession.value) * 100)}%`;
});

function toPersianDigits(value: number | string): string {
  return String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);
}

async function load() {
  loading.value = true;
  errorMessage.value = null;
  finished.value = false;
  index.value = 0;
  reviewedCount.value = 0;
  flipped.value = false;
  try {
    const session = await getLeitnerReview(20);
    cards.value = session.cards || [];
    if (!cards.value.length) finished.value = true;
  } catch (e) {
    errorMessage.value = handleError(e, "LeitnerReview.load");
  } finally {
    loading.value = false;
  }
}

async function answer(known: boolean) {
  const card = current.value;
  if (!card || submitting.value) return;
  submitting.value = true;
  try {
    await submitLeitnerReview(card.id, known);
    reviewedCount.value += 1;
    flipped.value = false;
    if (index.value + 1 >= cards.value.length) {
      finished.value = true;
    } else {
      index.value += 1;
    }
  } catch (e) {
    errorMessage.value = handleError(e, "LeitnerReview.answer");
  } finally {
    submitting.value = false;
  }
}

function goBack() {
  router.push("/dashboard/leitner");
}

function goOverview() {
  router.push("/dashboard/leitner");
}

onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "review__back",
        onClick: goBack
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "20",
          height: "20",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M5 12H19",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M13 6l6 6-6 6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1),
        _createElementVNode("span", null, "خروج از مرور", -1)
      ]))]),
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, {
            key: 0,
            message: "در حال بارگذاری کارت‌ها..."
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 1,
              message: errorMessage.value,
              onRetry: load
            }, null, 8, ["message"]))
          : (finished.value || !current.value)
            ? (_openBlock(), _createBlock(EmptyState, {
                key: 2,
                title: "مرور امروز تمام شد",
                message: "کارت آماده‌ای باقی نمانده. بعداً دوباره سر بزن."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "review__done-btn",
                    onClick: goOverview
                  }, " بازگشت به جعبه‌ها ")
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ width: progressWidth.value })
                    }, null, 4)
                  ]),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(toPersianDigits(reviewedCount.value)) + " از " + _toDisplayString(toPersianDigits(totalInSession.value)), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["review__card", { 'review__card--flipped': flipped.value }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (flipped.value = !flipped.value))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (current.value.box)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "جعبه " + _toDisplayString(toPersianDigits(current.value.box)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_8, _toDisplayString(current.value.word), 1),
                    (current.value.phonetic)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(current.value.phonetic), 1))
                      : _createCommentVNode("", true),
                    (current.value.part_of_speech)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(current.value.part_of_speech), 1))
                      : _createCommentVNode("", true),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "review__hint" }, "برای دیدن معنی کلیک کن", -1))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (current.value.box)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "جعبه " + _toDisplayString(toPersianDigits(current.value.box)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("h2", _hoisted_13, _toDisplayString(current.value.definition), 1),
                    (current.value.example)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, "“" + _toDisplayString(current.value.example) + "”", 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "review__btn review__btn--unknown",
                    disabled: submitting.value,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (answer(false)))
                  }, " بلد نیستم ", 8, _hoisted_16),
                  _createElementVNode("button", {
                    type: "button",
                    class: "review__btn review__btn--known",
                    disabled: submitting.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (answer(true)))
                  }, " بلدم ", 8, _hoisted_17)
                ])
              ], 64))
    ])
  ]))
}
}

})